import PropTypes from 'prop-types'

import iconStyle from './index.css'

const Icon = ({ icon, className, children, spin, labelPosition, ...props }) => {
  return (
    <i className={`${iconStyle.base} ${spin ? iconStyle.spin : ''} ${className}`} {...props}>
      {children && labelPosition === 'before' && <span>{children}</span>}
      {icon}
      {children && labelPosition === 'after' && <span>{children}</span>}
    </i>
  )
}

Icon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
  labelPosition: PropTypes.oneOf(['before', 'after']),
  alt: PropTypes.string,
  spin: PropTypes.bool
}

Icon.defaultProps = {
  className: '',
  labelPosition: 'after',
  spin: false
}

export default Icon
